import React, { Fragment } from 'react';
import ReactMarkdown from 'react-markdown';

class Blurbs extends React.Component{

  filterBlurbs = () => {
    let allBlurbs = this.props.texts;
      console.log('allBlurbs: ', allBlurbs);
    let pageBlurbs = allBlurbs.filter(bs => bs.Page === this.props.page);
      console.log('pageBlurbs: ', pageBlurbs);
    return pageBlurbs;
  }

  render() {

    const pageBlurbs = this.filterBlurbs();
      console.log('const pageBlurbs: ', pageBlurbs);

//    return(
//      <div>test</div>
//    )


    return(
      <Fragment>
        {
          pageBlurbs.map((obj, index) => {
            return(
              <Fragment key={index}>
                <p className="type">{obj.Tagline}</p>
                <h2>{obj.Title}</h2>
                <ReactMarkdown source={obj.Content} />
              </Fragment>
            )
          })
        }
      </Fragment>
    )

  }

}
export default Blurbs;



// WEBPACK FOOTER //
// ./src/components/Blurbs/blurbs.js